import { render, staticRenderFns } from "./TempCodeProvisionHistoryJournal.vue?vue&type=template&id=b4db72fc&scoped=true"
import script from "./TempCodeProvisionHistoryJournal.vue?vue&type=script&lang=js"
export * from "./TempCodeProvisionHistoryJournal.vue?vue&type=script&lang=js"
import style0 from "./TempCodeProvisionHistoryJournal.vue?vue&type=style&index=0&id=b4db72fc&prod&lang=scss&scoped=true"
import style1 from "./TempCodeProvisionHistoryJournal.vue?vue&type=style&index=1&id=b4db72fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4db72fc",
  null
  
)

export default component.exports